import { render, staticRenderFns } from "./case5.vue?vue&type=template&id=3a68fd66&scoped=true&"
import script from "./case5.vue?vue&type=script&lang=js&"
export * from "./case5.vue?vue&type=script&lang=js&"
import style0 from "./case5.vue?vue&type=style&index=0&id=3a68fd66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a68fd66",
  null
  
)

export default component.exports